import { switchNeverDefaultCase } from 'Utils/switchNeverDefaultCase';
import { MOCK_PRODUCT_ENHANCER_FIELDS } from '../mock-data';
import {
  IProductEnhancerField,
  EnhancedFieldsMapState,
  EProductEnhancerFieldTypes
} from '../types';

export const EnhancedGradientBorderColor =
  'linear-gradient(94.61deg, #1E96FC 9.23%, #9747FF 27.53%, #FF871F 49.49%, #FF6EC7 71.45%)';

export const EnhancedGradientCardBgColor =
  'linear-gradient(237.59deg, #F6F8FA 0.39%, #ECF3F8 100.76%)';

export const ORIGINAL_FIELDS_INITIAL_STATE: IProductEnhancerField[] = [
  ...MOCK_PRODUCT_ENHANCER_FIELDS
];

export const ENHANCED_FIELDS_INITIAL_STATE: EnhancedFieldsMapState =
  ORIGINAL_FIELDS_INITIAL_STATE.reduce<EnhancedFieldsMapState>(
    (acc, { data, ...fieldItem }) => {
      acc[fieldItem.id] = fieldItem;
      return acc;
    },
    {}
  );

export const ENHANCED_FIELDS_ENHANCED_STATE: EnhancedFieldsMapState =
  ORIGINAL_FIELDS_INITIAL_STATE.reduce<EnhancedFieldsMapState>(
    (acc, fieldItem) => {
      acc[fieldItem.id] = fieldItem;
      return acc;
    },
    {}
  );

export const ENHANCED_FIELDS_RE_ENHANCED_STATE: EnhancedFieldsMapState =
  ORIGINAL_FIELDS_INITIAL_STATE.reduce<EnhancedFieldsMapState>(
    (acc, fieldItem) => {
      const reEnhancedField = structuredClone(fieldItem);

      switch (reEnhancedField.type) {
        case EProductEnhancerFieldTypes.TAG:
          reEnhancedField.data = reEnhancedField.data.map(
            tag => `Re-Enhanced ${tag}`
          );
          break;
        case EProductEnhancerFieldTypes.TITLE:
          reEnhancedField.data = `Re-Enhanced ${reEnhancedField.data}`;
          break;
        case EProductEnhancerFieldTypes.TEXTAREA:
          reEnhancedField.data = `Re-Enhanced ${reEnhancedField.data}`;
          break;
        case EProductEnhancerFieldTypes.LABEL_VALUE:
          reEnhancedField.data = reEnhancedField.data.map(item => ({
            ...item,
            value: `Re-Enhanced ${item.value}`
          }));
          break;
        default:
          return switchNeverDefaultCase(reEnhancedField);
      }

      acc[fieldItem.id] = reEnhancedField;
      return acc;
    },
    {}
  );
